<template>
	<div></div>
</template>

<script>
	export default {
		name: 'Ground',

	}
</script>

<style scoped lang="scss">
	div {
		background-image: url('../../../assets/grass.png');
		background-repeat: repeat-x;

		position:fixed;
		left:0;
		bottom:0;

		width:100vw;
		height:39px;
	}
</style>


// WEBPACK FOOTER //
// src/components/objects/game/Ground.vue